import { render } from "./AExpansionPanelTitle.vue?vue&type=template&id=db8f5716&scoped=true"
import script from "./AExpansionPanelTitle.vue?vue&type=script&lang=js"
export * from "./AExpansionPanelTitle.vue?vue&type=script&lang=js"

import "./AExpansionPanelTitle.vue?vue&type=style&index=0&id=db8f5716&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8f5716"]])

export default __exports__